import { EducationPlanSchedules } from 'features/education-plan-schedules';
import { AppPage } from 'common/Layout';
import { useEducationPlanSchedulesPage } from './use-education-plan-schedules';

export const EducationPlanSchedulesPage = () => {
  const { breadcrumbsLoading, breadcrumbs, educationPlan } = useEducationPlanSchedulesPage();

  return (
    <AppPage
      breadcrumbs={{
        items: breadcrumbs,
        loading: breadcrumbsLoading,
      }}
      documentTitle={educationPlan?.name ?? 'Учебный план'}
    >
      <EducationPlanSchedules />
    </AppPage>
  );
};
